import React from 'react';

const Categories = () => {
  return (
    <div className="admin-categories">
      <h1>Manage Categories</h1>
      <p>Here you can view, create, edit, and delete blog categories.</p>
      
      <div className="categories-form card mt-2">
        <h3>Add New Category</h3>
        <form className="mt-1">
          <div className="form-group">
            <label htmlFor="categoryName">Category Name</label>
            <input type="text" id="categoryName" className="form-control" placeholder="Enter category name" />
          </div>
          <button type="button" className="btn btn-primary">Add Category</button>
        </form>
      </div>
      
      <div className="categories-list card mt-2">
        <h3>Existing Categories</h3>
        <p>No categories available yet.</p>
      </div>
    </div>
  );
};

export default Categories; 